import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { usePromiseTracker } from 'react-promise-tracker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CustomProvider } from 'rsuite';



const WaitingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    promiseInProgress &&
    <div className="text-center WaitMessage  text-success bg-white  shadow p-3">
      <img src="../assets/Images/Waiting1.gif" className="w-20p " /> &nbsp;&nbsp;
      لطفاً منتظر بمانید...</div>


  );
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div className='Container'>
    <CustomProvider theme="light">
      <App />
    </CustomProvider>
    {/* <App/> */}
    <WaitingIndicator />
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

